import { render, staticRenderFns } from "./ReportaProblem.vue?vue&type=template&id=6791c37c&scoped=true&"
import script from "./ReportaProblem.vue?vue&type=script&lang=js&"
export * from "./ReportaProblem.vue?vue&type=script&lang=js&"
import style0 from "./ReportaProblem.vue?vue&type=style&index=0&id=6791c37c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6791c37c",
  null
  
)

export default component.exports